// 格式化日期
let formatDate = function (date, format) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return format
}

let getDateByStr = function (dateStr) {
  if (typeof (dateStr) !== 'string') {
    return null
  }
  if (dateStr.indexOf('T') > 0) {
    return getDateByJsonStr(dateStr)
  }
  var times = Date.parse(dateStr)
  return new Date(times)
}

// 处理2018-01-11T22:41:45 类型的JSON日期格式
let getDateByJsonStr = function (dateStr) {
  dateStr = dateStr.replace('T', ' ')
  return new Date(dateStr.replace(/-/g, '/'))
}
// 格式话JSON日期
let formatJsonDate = function (date, format) {
  if (typeof (date) === 'string') {
    date = getDateByStr(date)
  }
  return formatDate(date, format)
}
// 返回
const datetimeFormat = function (value, formater) {
  return formatJsonDate(value, formater)
}

export default datetimeFormat



// WEBPACK FOOTER //
// ./src/filter/datetime.js